/**
 * external dependencies
 */
import { Tabulator, FilterModule } from 'tabulator-tables';

/**
 * Searches a table and returns a value givin the input. This function also
 * handles clearing the search input and hiding the clear button.
 * 
 * @param {HTMLInputElement} searchElement the HTML input element
 * @param {Tabulator} table the table being searched
 * 
 */
export const tableSearchInput = (searchElement: HTMLInputElement, table: Tabulator) => {
  const clearSearch = document.querySelector('.aafp_text-field-clear') as HTMLElement;
  const toggleCont = document.querySelector('.aafp_text-field') as HTMLElement;
  Tabulator.registerModule([ FilterModule ]);

  let timeout: NodeJS.Timeout;

  const handleSearch = () => {
    const search = searchElement.value;
    const filters = table.getColumns().map(column => ({
      field: column.getField(),
      type: 'like',
      value: search
    }));

    table.setFilter([filters]);
  };

  const handleFocus = () => {
    clearSearch.style.display = 'block';
  };

  const handleClear = () => {
    searchElement.value = '';
    clearSearch.style.display = 'none';
    table.clearFilter(true);
  };

  searchElement.addEventListener('keyup', () => {
    clearTimeout(timeout);
    timeout = setTimeout(handleSearch, 300);
  });

  searchElement.addEventListener('focus', handleFocus);

  document.addEventListener('click', (event: any) => {
    if (toggleCont !== event.target && !toggleCont.contains(event.target) && searchElement.value === '') {
      clearSearch.style.display = 'none';
    }
  });

  clearSearch.addEventListener('click', handleClear);
}